<template>
  <div class="position-relative">
    <div v-if="currentStatus == 1 || currentStatus == 0" class="status-circle d-inline-block" :class="(currentStatus == 1)? 'connected' : 'disconnected'"></div>
    {{ (currentStatus == 1)? 'On' : 'Off'}}
    <div @click="makeAction" class="pointer-cursor d-inline-block" style="position: absolute;right: 1px;">
        <span v-if="currentStatus == 1" class="text-danger">
          <i class="el-icon-video-pause"></i> Stop
        </span>
        <span v-if="currentStatus == 0" class="text-success">
          <i class="el-icon-video-play"></i> Start
        </span>
    </div>
  </div>
</template>

<script>

import {notify} from "@/system-services/notify";

export default {
  props: {
    status: {
      required: true
    },
    testId: {
      required: true
    }
  },
  data () {
    return {
      currentStatus: this.status
    }
  },
  methods: {
    ...$mapActions('voip-test-automation-api', {
      stopTest: 'stopTest',
      startTest: 'startTest'
    }),
    IsJsonString(str) {
      try {
        JSON.parse(str)
      } catch (e) {
        return false;
      }
      return true;
    },
    makeAction () {
      if (this.currentStatus == 1) {
        this.currentStatus = -1
        this.stopTest({id: this.testId}).then( r => {
          setTimeout(() => {
            this.currentStatus = 0
            notify({
              type: 'success',
              title: "Stopped",
            });
          }, 2000)

        })
      } else if (this.currentStatus == 0) {
        this.currentStatus = -1
        this.startTest({id: this.testId}).then( r => {
          setTimeout(() => {
            this.currentStatus = 1
            notify({
              type: 'success',
              title: "started",
            });
          }, 2000)
        }).catch( error => {
          this.currentStatus = -1
          let responseData = error.response.data.message
          if(this.IsJsonString(responseData)) {
            let data = JSON.parse(responseData)
            let status = data.status


            if (status == 200) {
              setTimeout(() => {
                this.currentStatus = 1
                notify({
                  type: 'success',
                  title: 'started',
                });
              }, 2000)
            } else {
              this.currentStatus = 0
              notify({
                type: 'error',
                title: 'Failed',
              });
            }
          } else {
            this.currentStatus = 0
            notify({
              type: 'error',
              title: 'Failed',
            });
            console.log('catch error', error)
          }
        })
      }
    }
  }
}
</script>
